import { MdCheck } from "react-icons/md";
import { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import styles from "../../Checkout.module.scss";

const LIMIT_IN_HOURS = 24;

const isLimitAttractive = (limitInHours: number) =>
  limitInHours <= LIMIT_IN_HOURS;

interface Props {
  limitInHours: number;
}

export default function CancellationPolicyIncentive({ limitInHours }: Props) {
  const [openCancelPolicy, setOpenCancelPolicy] = useState(false);
  const onOpenCancelModal = () => setOpenCancelPolicy(true);
  const onCloseCancelModal = () => setOpenCancelPolicy(false);
  return isLimitAttractive(limitInHours) ? (
    <div
      style={{
        textAlign: "center",
        marginTop: 12,
        fontWeight: 400,
        fontSize: 11,
      }}
    >
      <MdCheck
        style={{
          position: "relative",
          top: 2,
        }}
      />{" "}
      <b>Free Cancellation</b> {limitInHours} hours in advance{" "}
      <span
        style={{
          cursor: "pointer",
          textDecoration: "underline",
        }}
        onClick={onOpenCancelModal}
      >
        Learn more
      </span>
      <Modal
        open={openCancelPolicy}
        blockScroll={false}
        onClose={onCloseCancelModal}
        classNames={{
          modal: styles.CustomModal,
        }}
      >
        <p
          style={{
            fontSize: 26,
            fontWeight: "bold",
            paddingBottom: 10,
            borderBottom: "1px solid",
            marginBottom: 20,
            marginTop: 40,
          }}
        >
          Free cancellation up to 24 hours
        </p>
        <p
          style={{
            fontWeight: "bold",
            marginBottom: 20,
          }}
        >
          Secure your seat now! <br /> You can cancel or reschedule{" "}
          <span style={{ textDecoration: "underline" }}>up to 24 hours</span> in
          advance of the tour for a full refund.{" "}
        </p>
        <ul
          style={{
            listStyle: "disc",
            lineHeight: "2em",
            padding: 15,
            fontSize: 14,
          }}
        >
          <li>
            {" "}
            For a full refund, you must cancel at least 24 hours before the
            experience&apos;s start time.{" "}
          </li>
          <li>
            If you cancel less than 24 hours before the tour&apos;s start time,
            the amount you paid will not be refunded.
          </li>
          <li>
            You may cancel or reschedule through the link on the confirmation
            email you receive after booking.
          </li>
          <li>
            Any changes made less than 24 hours before the experience&apos;s
            start time will not be accepted.
          </li>
          <li>Cut-off times are based on the experience&apos;s local time.</li>
        </ul>
      </Modal>
    </div>
  ) : null;
}
